export default "__VITE_ASSET__c37b4c7d__"